import { MetricEntry, MetricEntryMode } from 'shared/types/goal-metric';
import { ID } from 'shared/types/id';

export const calculateMetricEntryValue = (
  id: ID,
  entries: MetricEntry[],
  startValue: number,
) => {
  const targetEntry = entries.find((entry) => entry.id === id);
  if (!targetEntry) {
    return startValue;
  }

  if (targetEntry.mode === MetricEntryMode.Absolute) {
    return targetEntry.value;
  }

  // Pre-sort entries by date for performance
  const sortedEntries = entries.toSorted(
    (entryA, entryB) => entryA.date.getTime() - entryB.date.getTime(),
  );

  const targetIndex = sortedEntries.findIndex((entry) => entry.id === id);
  const previousEntries = sortedEntries.slice(0, targetIndex + 1);
  const lastAbsolute = previousEntries
    .reverse()
    .find((entry) => entry.mode === MetricEntryMode.Absolute);

  const baseValue = lastAbsolute ? lastAbsolute.value : startValue;
  const startIndex = lastAbsolute
    ? sortedEntries.findIndex((entry) => entry.id === lastAbsolute.id) + 1
    : 0;

  return (
    Math.round(
      sortedEntries
        .slice(startIndex, targetIndex + 1)
        .reduce(
          (sum, entry) =>
            sum + (entry.mode === MetricEntryMode.Relative ? entry.value : 0),
          baseValue,
        ) * 100,
    ) / 100
  );
};
